import mixpanel from 'mixpanel-browser';
import { getUserData } from '@/Utils/userSession';

// Exposing window.mixpanel for UG to use.
window.mixpanel = mixpanel;
const MIXPANEL_TOKEN = 'ada79c86ae2d13a966ae9b16289c6810';

if (process.env.NODE_ENV === 'production') {
  // Proxy instance — all of our custom analytics
  mixpanel.init(
    MIXPANEL_TOKEN,
    {
      api_host: 'https://api.gigasheet.com/mixpanel',
      api_payload_format: 'json',
    },
    'proxyMP'
  );

  // Native instance — for session‐recording only
  mixpanel.init(
    MIXPANEL_TOKEN,
    {
      record_sessions_percent: 100, //records 100% of all sessions
    },
    'directMP'
  );
}
const url_check = window.location.host === 'app.gigasheet.com';

export const Mixpanel = {
  identify: (id) => {
    if (url_check) mixpanel.proxyMP.identify(id);
  },
  identifyDirect: (id) => {
    if (url_check) mixpanel.directMP.identify(id);
  },
  alias: (id) => {
    if (url_check) mixpanel.proxyMP.alias(id);
  },
  track: (name, props) => {
    if (process.env.NODE_ENV !== 'test') {
      if (url_check) {
        const user = getUserData();
        const userEmail = user?.email;
        const deviceInfo = navigator.platform;

        mixpanel.proxyMP.track(name, {
          ...props,
          'Device Info': deviceInfo,
          user_name: userEmail,
          distinct_id: userEmail,
        });
      }
    }
  },
  register: (props) => {
    if (url_check) mixpanel.proxyMP.register(props);
  },
  registerDirect: (props) => {
    if (url_check) mixpanel.directMP.register(props);
  },
  people: {
    set: (props) => {
      if (url_check) mixpanel.proxyMP.people.set(props);
    },
    increment: (property, amount) => {
      if (url_check) mixpanel.proxyMP.people.increment(property, amount);
    },
  },
};
